import { render, staticRenderFns } from "./okay-modal.vue?vue&type=template&id=6f212f72"
import script from "./okay-modal.vue?vue&type=script&lang=js"
export * from "./okay-modal.vue?vue&type=script&lang=js"
import style0 from "./okay-modal.vue?vue&type=style&index=0&id=6f212f72&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports